import * as yup from 'yup';
import * as utils from './utils';
import { Entente } from '../entities';

export const schemaEntente = yup.object<Partial<Entente>>({
    name: yup.string().nullable(),
    fk_id_client: yup.number().required('Le client associé est obligatoire'),
    fk_id_lieu: yup.number().required('Le lieu associé est obligatoire'),
    contexte: yup.string().required('Le contexte est obligatoire'),
    statut: yup.string().nullable(),
    date_activite: utils.toStringSchema(yup.date().required('Ce champ est requis')),
}) as yup.ObjectSchema<Partial<Entente>>;
